import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { client } from '@authy/lib-client/trpc'

import { rootRoute } from '@/tenant/settings/root'
import { appState } from '@/appState'

export const securityRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/security',
    component: lazyRouteComponent(() => import('./Security'), 'Security'),
    loader: async ({ abortController, parentMatchPromise }) => {
        await parentMatchPromise

        const securitySettings = await client.tenants.getTenantSecuritySettings.query(
            {
                tenantId: appState.tenant!._id.toString(),
            },
            { signal: abortController.signal }
        )

        return { securitySettings }
    },
})
